import { faBook, faGavel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Container, Row } from 'reactstrap';
import { useAppDispatch } from '../hooks/index';
import { setTaxonomyType } from '../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';
import MenuTile from './core/MenuTile';
import CanShowGivenAdminUserRole from './feature/CanShowGivenAdminUserRole';
import { AdminUserRoleEnum } from '../redux/UserSlice';



const AdminMenu = () => {

    const dispatch = useAppDispatch();

    const permittedAdminRoleValues: Array<AdminUserRoleEnum> = [
        AdminUserRoleEnum.Admin,
        AdminUserRoleEnum.UserManager
    ]

    React.useEffect(() => {

        dispatch(setTaxonomyType(TaxonomyTypeEnum.AFR));

    }, []);


    return (
        <Container fluid>
            <Row style={{
                paddingTop: '2em',
                display: "flex",
                alignContent: "flex-start",
                columnGap: "2em"
            }}>
                <MenuTile tileLink="/EntityAFRManagementA"
                    tileTitle="AFR Management"
                    tileDescription="Used to review AFR Records (Admin)" icon="bi bi-ui-checks" />

                <MenuTile tileLink="/AFRAssignment"
                    tileTitle="AFR Assignment"
                    tileDescription="Used to track the assignment and reconciliation of the AFRs" icon="bi bi-arrow-left-right" />

                <MenuTile tileLink="/CreateAFRs"
                    tileTitle="Create AFR Records"
                    tileDescription="Create AFR Records for a new reporting Fiscal Year" icon="bi bi-file-earmark-plus-fill" />

                <MenuTile tileLink="/EntityManagementA"
                    tileTitle="Entity Management"
                    tileDescription="Create or edit a Local Goverment Entity" icon="bi bi-bank" />

                <MenuTile tileLink="/AuditFirmManagement"
                    tileTitle="Audit Firm Management"
                    tileDescription="Review pending and existing Audit Firms" icon="bi bi-briefcase-fill" />

                <CanShowGivenAdminUserRole
                    permittedRoles={permittedAdminRoleValues} >
                    <MenuTile tileLink="/AdminManager"
                        tileTitle="User Management"
                        tileDescription="Create or deprecate a Local Goverment User" icon="bi bi-people-fill" />
                </CanShowGivenAdminUserRole>

                <CanShowGivenAdminUserRole
                    permittedRoles={permittedAdminRoleValues}>
                    <MenuTile tileLink="/AccountCodeManagement"
                        tileTitle="Account Codes"
                        tileDescription="Create, edit, or deprecate account codes" icon="bi bi-file-medical" />
                </CanShowGivenAdminUserRole>

                <MenuTile tileLink="/PublicReportsMenu"
                    tileTitle="Reports"
                    tileDescription="Launch Reports for selected AFRs" icon="bi bi-journal-arrow-down" />

                <MenuTile tileLink="https://myfloridacfo.com/division/aa/local-governments"
                    tileTitle="Manuals"
                    tileDescription="Manuals"
                    icon={<FontAwesomeIcon className="menuIcon" icon={faBook} />}
                    tileType="link" />

                <CanShowGivenAdminUserRole
                    permittedRoles={permittedAdminRoleValues}>
                    <MenuTile tileLink="/TaxonomyManagement"
                        tileTitle="Taxonomy Management"
                        tileDescription="Upload, Update or Generate taxonomies" icon="bi bi-diagram-3" />
                </CanShowGivenAdminUserRole>

                <MenuTile tileLink="/CourtReportingOptions"
                    tileTitle="Court Reporting"
                    tileDescription="Upload, Update or Review 939 and 29.0085 Court reports"
                    icon={<FontAwesomeIcon className="menuIcon" icon={faGavel} />}
                    tileType="fontawesome" />

                <CanShowGivenAdminUserRole
                    permittedRoles={permittedAdminRoleValues}>
                    <MenuTile tileLink="/DepartmentStaffManagement"
                        tileTitle="Department Staff Management"
                        tileDescription="Manage Staff Assignments for DFS Departments" icon="bi bi-people-fill" />
                </CanShowGivenAdminUserRole>

            </Row>
        </Container>
    );
}

export default AdminMenu;